import { Box } from '@mui/material'
import { alpha } from '@mui/material/styles'
import { ACCENT_BLUE } from 'utils/brand-colors'

const escapeRegExp = (value: string) => value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')

interface HighlightTextProps {
  text: string | null | undefined
  query: string
  emptyFallback?: string
}

/** Highlights the first case-insensitive match of query inside text. */
export const HighlightText = ({ text, query, emptyFallback = '—' }: HighlightTextProps) => {
  const display = text == null || text === '' ? emptyFallback : text
  const trimmedQuery = query.trim()
  if (!trimmedQuery || display === emptyFallback) {
    return <>{display}</>
  }

  const parts = display.split(new RegExp(`(${escapeRegExp(trimmedQuery)})`, 'gi'))
  if (parts.length === 1) {
    return <>{display}</>
  }

  return (
    <>
      {parts.map((part, index) =>
        part.toLowerCase() === trimmedQuery.toLowerCase() ? (
          <Box
            component="mark"
            key={`${index}-${part}`}
            sx={{
              bgcolor: alpha(ACCENT_BLUE, 0.22),
              color: 'inherit',
              px: 0.25,
              borderRadius: '2px',
            }}
          >
            {part}
          </Box>
        ) : (
          <span key={`${index}-${part}`}>{part}</span>
        )
      )}
    </>
  )
}
